// TODO: add image option

import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-aside',
  styleUrl: 'aside.css',
  shadow: true,
})
export class Aside {
  @Prop() heading: string = "Heading";

  render() {
    return (
      <Host>
        <div class="heading">{this.heading}</div>
        {/* Img goes here */}
        <div class="content">
          <slot />
        </div>
      </Host>
    );
  }
}
